<template>
    <div>   
        <div v-if="customerList">
            
            <div v-for="(customer,index) in Object.values(customerList)" :key="index" class="list-group">
                <h3>{{customer.phone}}</h3>
                <div v-for="(planID,index) in Array.from(new Set(Object.values(customer.tickets).map(a=>a.planID)))" :key="index" >
                    <div :id="planID" class="list-group-item list-group-item-light" @click="toggleList">
                        {{Object.values(customer.tickets).map(a=>a.planID == planID?a.planName:null).filter(a=>a!=null)[0]}}
                        <!-- <small>{{planID}}</small> -->
                    </div>
                    <div :id="planID+'-tickets'" class="hide">
                        <div v-for="(ticket,index) in Object.values(customer.tickets).map(a=>a.planID == planID?a:null).filter(a=>a!=null)" 
                            :key="index" class=""
                        >
                            <a :href="'/ticket/'+userID+'|'+ticket.ticketID" class="list-group-item list-group-item-action">
                                <img v-if="ticket.planImages" style="" class="col-12 col-md-4" :src="ticket.planImages.front">
                                <!-- <small>{{ticket.ticketID}}</small> -->
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div v-if="!customerList&&!isLoading">
            Can not get ticket list.
        </div>
        <div v-if="isLoading">
            Loading...
            Status: {{status}}
        </div>
    </div>    
</template>
<script>
import firebase from 'firebase';

export default {
    data(){
        return {
            customerObj:{
                PSID:'955879974536136',
            },
            isLoading:true,
            customerList:null,
            pageID:'',
            userID:'',
            status:''

        }
    },
    watch:{
        customerObj:{
            handler(value){
                if(value.PSID)
                    this.getCustomerList();
            },
            deep:true
        }
    },
    methods:{
        getCustomerList(){
            console.log('Getting Customer Ticket List...');
            var self = this;
            self.userID = self.$route.params.key.split('|')[0];
            self.pageID = self.$route.params.key.split('|')[1];
            var databaseRef = firebase.database().ref('users/' + self.userID + '/customers/')
                .orderByChild('messengerPSID/'+self.pageID).equalTo(self.customerObj.PSID);
            //TODO: index on dynamic fan page id
            return databaseRef.once('value')
                .then(snapshot=>{
                    if(snapshot.val()){
                        console.log('Found Customer Tickets');
                        self.status = 'Found Customer Tickets';
                        console.log(snapshot.val());
                        self.isLoading = false;
                        self.customerList =snapshot.val();
                    }else{
                        console.log('Customer tickets not found');
                        self.isLoading = false;
                        self.status = 'Customer tickets not found';
                    }

                },error=>{
                    console.log('Getting Customer Ticket List error '+ error);
                    self.status = 'Getting Customer Ticket List error ';
                })
        },
        getMessengerPSID(){
            //For Dev use only
            if(process.env.VUE_APP_STAGE == 'development'){
                this.customerObj.PSID = '2031391683591467';
                this.status = 'got PSID: ' + '2031391683591467';
                return true;
            }
            
            var self = this;
            MessengerExtensions.getContext('1812213338901699', //APP ID
                function success(thread_context){
                    self.customerObj.PSID = thread_context.psid;
                    self.status = 'got PSID: ' + thread_context.psid;
                },
                function error(err){
                    console.log('get messenger PSID error:');
                    console.log(err);
                    self.status = 'get messenger PSID error:';
                }
            );
        },
        initMessengerExtension(){
            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/messenger.Extensions.js";
                fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'Messenger'));
            window.extAsyncInit = this.onMessengerSDKLoaded;
        },
        onMessengerSDKLoaded(){
            console.log('the Messenger Extensions JS SDK is done loading ');
            this.getMessengerPSID();//推上Staging才拿得到PSID
        },
        toggleList(e){
            var d = document.getElementById(e.currentTarget.id + '-tickets');
            if(d.classList.contains('hide'))
                d.classList.remove('hide');
            else
                d.classList.add('hide');
        }
    },
    mounted(){
        this.initMessengerExtension();
    },
    created(){
        document.title = this.$t('Ticket List');
    }
}
</script>
<style scoped>
.hide{
    display: none;
}

</style>
